import React from 'react'
import classNames from 'classnames'

// How one opportunity's calls broke down: converted / didn't convert /
// inconclusive. Three solid zones summing to 100% of the opportunity's calls,
// with a wrap-safe key underneath. Zone widths are dynamic so they use inline
// width (same pattern as the experiment progress bars); colors are classes.
const ZONES = [
  { key: 'converted', label: 'Converted' },
  { key: 'didntConvert', label: "Didn't convert" },
  { key: 'inconclusive', label: 'Inconclusive' },
]

export const CompositionBar = ({ convertedPct, didntConvertPct, inconclusivePct }) => {
  const values = {
    converted: convertedPct,
    didntConvert: didntConvertPct,
    inconclusive: inconclusivePct,
  }

  return (
    <div className="composition-bar">
      <div className="composition-bar__track">
        {ZONES.map((zone) => (
          <div
            key={zone.key}
            className={classNames('composition-bar__zone', `composition-bar__zone--${zone.key}`)}
            style={{ flexGrow: values[zone.key] }}
          />
        ))}
      </div>
      <div className="composition-bar__key">
        {ZONES.map((zone) => (
          <span key={zone.key} className="composition-bar__key-item">
            <span
              className={classNames(
                'composition-bar__swatch',
                `composition-bar__swatch--${zone.key}`
              )}
            />
            {zone.label} <b>{Math.round(values[zone.key])}%</b>
          </span>
        ))}
      </div>
    </div>
  )
}
